import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Close,
  Edit,
  KeyboardArrowDown,
  UploadOutlined,
  Visibility,
} from "@mui/icons-material";
import {
  IconCheck,
  IconCheckDone,
  IconDeleteRow,
  IconEdit,
  IconError,
  IconInputError,
  IconInvalidUrl,
  IconWarning,
} from "@app/components/icons";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  FormControl,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
  useMediaQuery,
  Skeleton,
} from "@mui/material";
import {
  handleUploadStore,
  REGEX,
  resetIsContinuousLoading,
  isValidMediaFile,
} from "@app/helpers";
import { MachineInfoType, theme } from "@app/types";

import { DataDialog, DataTooltip } from "@app/components/atoms";
import {
  INVALID_URL,
  KOMATSU_MANUFACTURER_ID,
  OTHER_MACHINE_TYPE_ID,
  OTHER_MANUFACTURER_ID,
  TYPE_FILE_UPLOAD,
  UploadFileType,
} from "@app/constants";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useParams } from "react-router-dom";
import {
  apiGenerateQRPdf,
  apiGetMachineDetailInfo,
  apiGroupMachineManufacturers,
  apiGroupMachineTypes,
  apiMachineQR,
  apiUpdateMachineInGroup,
  apiUpdateMachineInGroupStatus,
  getUser,
  getUserPermissions,
} from "@app/api";
import heic2any from "heic2any";
import { MediaUploadMachine } from "@app/pages/Features/GroupList/GroupDetail/Components/InspectionForm/MediaUpload/MediaUploadMachine";
import { setIsLoading, setShowAlert, store } from "@app/store";
import "@app/pages/Features/MachineDetail/Components/MachineInfo/MachineInfo.css";
import { ImageCropDialog } from "@app/pages/Features/GroupList/GroupDetail/Components/InspectionForm/MediaUpload/ImageCropDialog";
import { MachineMemoSection } from "./MachineMemoSection";
import { buildMachineUpdatePayloadFromDetail } from "./machineUpdatePayload.helper";

type MachineInfoProps = {
  onBack?: () => void;
  machineInfo?: MachineInfoType;
  refreshMachineInfo: () => void;
};

export function MachineInfo({
  onBack = () => {},
  machineInfo = {} as MachineInfoType,
  refreshMachineInfo,
}: MachineInfoProps) {
  const { t } = useTranslation();

  const [showContentDrop, setShowContentDrop] = useState(true);
  const [machineInfoPictureUrl, setMachineInfoPictureUrl] = useState<
    string | undefined
  >();
  const [serialNumberPlatePictureUrl, setSerialNumberPlatePictureUrl] =
    useState<string | undefined>();
  const [open, setOpen] = useState(false);
  const { groupId, machineId } = useParams();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const openMenu = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    if (!groupId || !machineId) return;

    fetchMachineManufacturers(groupId);
    fetchMachineTypes(groupId);
    fetchMachineDetail(groupId, machineId);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleOnClick = (machineInfo: MachineInfoType) => {
    if (!machineInfo?.serialNumberPlatePictureUrl) return;
    setOpen(true);
  };
  const [QRPictureUrl, setQRPictureUrl] = useState<string | undefined>();
  const [QRLoading, setQRLoading] = useState<boolean>(false);
  useEffect(() => {
    if (machineInfo?.pictureUrl)
      setMachineInfoPictureUrl(machineInfo.pictureUrl);
    if (machineInfo?.serialNumberPlatePictureUrl)
      setSerialNumberPlatePictureUrl(machineInfo.serialNumberPlatePictureUrl);
  }, [machineInfo]);
  enum MACHINE_CONDITION {
    NORMAL = "NORMAL",
    WARNING = "WARNING",
    ERROR = "ERROR",
  }
  const STATUS_ICONS = {
    NORMAL: <IconCheck />,
    WARNING: <IconWarning />,
    ERROR: <IconError />,
  };
  const [machineStatus, setMachineStatus] = useState<MACHINE_CONDITION | "">(
    "",
  );
  const [openMachineDetails, setOpenMachineDetails] = useState(false);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [customerMachineNumber, setCustomerMachineNumber] = useState("");
  const [makerOther, setmakerOther] = useState<string | null>(null);
  const [machineTypeOther, setmachineTypeOther] = useState<string | null>(null);
  const [modelType, setmodelType] = useState<string | null>(null);
  const [serialNo, setserialNo] = useState<string | null>(null);
  const [manufacturer, setmanufacturer] = useState<string | null>(null);
  const [machinetypes, setmachinetypes] = useState<string | null>(null);
  const [, setSelectedImageSerial] = useState<string | null>(null);
  const [mediaFiles, setMediaFiles] = useState<File[]>([]);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [pictureFiles, setPictureFiles] = useState<File[]>([]);
  const [isImageRemoved, setIsImageRemoved] = useState(false);
  const [fileError, setFileError] = useState<null | string>(null);
  const [machineNumberError, setMachineNumberError] = useState<string | null>(
    null,
  );
  const [makerOtherError, setMakerOtherError] = useState<string | null>(null);
  const [machineTypeOtherError, setMachineTypeOtherError] = useState<
    string | null
  >(null);
  const [modelTypeError, setModelTypeError] = useState<string | null>(null);
  const [, setSerialNumberFiles] = useState<File[]>([]);
  const [serialNoError, setSerialNoError] = useState(false);
  const [forbiddenCharError, setForbiddenCharError] = useState(false);
  const [manufacturers, setManufacturers] = useState<any[]>([]);
  const [machinetype, setmachinetype] = useState<any[]>([]);
  const [isImageRemovedSerial, setIsImageRemovedSerial] = useState(false);
  const [, setFileErrorSerial] = useState<null | string>(null);
  const [refreshKey] = useState(0);
  const [, setFileCount] = useState(0);
  const [, setRemovedMediaUrls] = useState<string[]>([]);
  const [openMachineDetailsStatus, setOpenMachineDetailsStatus] =
    useState(false);
  const [activeStatus, setActiveStatus] = useState<MACHINE_CONDITION | "">("");
  const pdfRef = useRef<HTMLDivElement>(null);
  const [userTimeFormat, setUserTimeFormat] = useState("dd/MM/yyyy");

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const res = await getUser();
        const { data } = res.data;

        if (!data) {
          resetIsContinuousLoading();
          return;
        }

        setUserTimeFormat(data.timeFormat);
      } catch (error) {
        console.error("Failed to load Me:", error);
      } finally {
        resetIsContinuousLoading();
        store.dispatch(setIsLoading(false));
      }
    };

    fetchMe();
  }, [groupId]);

  useEffect(() => {
    setActiveStatus(machineStatus);
  }, [machineStatus, openMachineDetailsStatus]);
  const uploadDescription = [
    `${t("textDesUploadFile.pleaseUploadAFileShowingTheMachinePoints")}`,
    `${t("textDesUploadFile.fileFormatsThatCanBeUploadedAre")}`,
  ];
  const fetchMachineManufacturers = async (groupId: string) => {
    try {
      const response = await apiGroupMachineManufacturers(groupId);

      setManufacturers(response.data.data || []);
    } catch (error) {
      console.error("Error fetching machine manufacturers:", error);
    }
  };
  const fetchMachineTypes = async (groupId: string) => {
    try {
      const response = await apiGroupMachineTypes(groupId);

      setmachinetype(response.data.data || []);
    } catch (error) {
      console.error("Error fetching machine types:", error);
    }
  };
  const fetchMachineDetail = async (groupId: string, machineId: string) => {
    try {
      const response = await apiGetMachineDetailInfo(groupId, machineId);
      const data = response.data;
      const serialImageURL = data?.data?.serialNumberPlatePictureUrl;

      const serialImagePath = data?.data?.serialNumberFilePath;

      setCustomerMachineNumber(data.data.machineName || "");
      setmakerOther(data.data.customMachineManufacturerName || "");
      setmachineTypeOther(data.data.customTypeName || "");
      setmodelType(data.data.modelAndType || "");
      setserialNo(data.data.serialNumber || "");
      setmanufacturer(data.data.machineManufacturerId || "");
      setmachinetypes(data.data.machineTypeId || "");
      setSelectedImage(data.data.pictureUrl || "");
      setSelectedImageSerial(data.data.serialNumberPlatePictureUrl || "");

      setMachineStatus(data.data.machineCondition || "");

      if (serialImageURL) {
        const response = await fetch(serialImageURL);
        const blob = await response.blob();

        const fullFileName = serialImagePath.substring(
          serialImagePath.lastIndexOf("/") + 1,
        );
        const fileName = fullFileName.substring(fullFileName.indexOf("-") + 1);

        const file = new File([blob], fileName, { type: blob.type });

        setMediaFiles([file]);
      } else {
        console.warn("Serial image not found for the selected row.");
      }
    } catch (error) {
      console.error("Error fetching machine details:", error);
    }
  };

  const handleMachineNumberChange = (value: string) => {
    setCustomerMachineNumber(value);

    const isValid =
      REGEX.commonNameFieldRegex.test(value) && REGEX.emojiRegex.test(value);

    if (isValid) {
      setMachineNumberError(null);
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setMachineNumberError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setMachineNumberError(t("emojisarenotallowed"));
    }
  };
  const handleMakerOtherChange = (value: string) => {
    setmakerOther(value);

    const isValid =
      REGEX.commonNameFieldRegex.test(value) && REGEX.emojiRegex.test(value);

    if (isValid) {
      setMakerOtherError(null);
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setMakerOtherError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setMakerOtherError(t("emojisarenotallowed"));
    }
  };
  const handleMachineTypeOtherChange = (value: string) => {
    setmachineTypeOther(value);

    const isNonEmpty = value.trim() !== "";
    const isValid =
      isNonEmpty &&
      REGEX.commonNameFieldRegex.test(value) &&
      REGEX.emojiRegex.test(value);

    if (isValid) {
      setMachineTypeOtherError(null);
    } else if (!REGEX.commonNameFieldRegex.test(value)) {
      setMachineTypeOtherError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(value)) {
      setMachineTypeOtherError(t("emojisarenotallowed"));
    }
  };
  const handleModelTypeChange = (value: string) => {
    const isKomatsuMachine = manufacturer === KOMATSU_MANUFACTURER_ID;
    let processedValue = value;
    if (isKomatsuMachine) {
      processedValue = value
        .replace(/[‐‑–—‐‑‒–—⁃‑‒–—﹘―⎯⏤ーｰ─━－ー]/g, "-")
        .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (match) =>
          String.fromCharCode(match.charCodeAt(0) - 0xfee0),
        );
    }

    processedValue = processedValue
      .replace(
        /[^a-zA-Z0-9\s-_\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF\uFF21-\uFF3A\uFF41-\uFF5A\uFF10-\uFF19\uFF0D]/g,
        "",
      )
      .replace(/^\s+/, "");

    if (isKomatsuMachine) {
      processedValue = processedValue.replace(/\s/g, "").toUpperCase();
    }

    setmodelType(processedValue);

    const isNonEmpty = processedValue.trim() !== "";
    const isValid =
      isNonEmpty &&
      REGEX.commonNameFieldRegex.test(processedValue) &&
      REGEX.emojiRegex.test(processedValue);

    if (isValid) {
      setModelTypeError(null);
    } else if (!isNonEmpty) {
      setModelTypeError(t("requiredNew"));
    } else if (!REGEX.commonNameFieldRegex.test(processedValue)) {
      setModelTypeError(t("invalidCharacters"));
    } else if (!REGEX.emojiRegex.test(processedValue)) {
      setModelTypeError(t("emojisarenotallowed"));
    }
  };

  const clearImageState = () => {
    if (selectedImage) {
      URL.revokeObjectURL(selectedImage);
    }

    if (cropImage) {
      URL.revokeObjectURL(cropImage);
    }

    if (originalCropImage) {
      URL.revokeObjectURL(originalCropImage);
    }

    setSelectedImage(null);
    setPictureFiles([]);
    setCropImage("");
    setOriginalCropImage("");
    setCropFileName("");
    setOriginalCropFileName("");
    setIsImageRemoved(false);
    setFileError(null);
  };

  const handleSerialNumberChange = (value: string) => {
    let processedValue = value
      .replace(
        /[^a-zA-Z0-9\s-_\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF\uFF21-\uFF3A\uFF41-\uFF5A\uFF10-\uFF19\uFF0D]/g,
        "",
      )
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (match) =>
        String.fromCharCode(match.charCodeAt(0) - 0xfee0),
      );

    if (manufacturer === KOMATSU_MANUFACTURER_ID) {
      processedValue = processedValue.replace(/\s/g, "").toUpperCase();
    }

    setserialNo(processedValue);

    let hasError = false;
    setSerialNoError(false);
    setForbiddenCharError(false);

    if (manufacturer === KOMATSU_MANUFACTURER_ID) {
      const isValidSerial =
        machinetypes === OTHER_MACHINE_TYPE_ID
          ? /^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
              processedValue,
            )
          : /^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
              processedValue,
            );
      setSerialNoError(!isValidSerial);
      hasError = !isValidSerial;
    } else {
      hasError = processedValue.length > 20;
      setSerialNoError(hasError);
    }
  };

  useEffect(() => {
    if (!groupId || !machineId) return;

    fetchMachineManufacturers(groupId);
    fetchMachineTypes(groupId);
    fetchMachineDetail(groupId, machineId);
  }, [groupId, machineId]);

  useEffect(() => {
    if (manufacturer !== KOMATSU_MANUFACTURER_ID) {
      setSerialNoError(false);
      setForbiddenCharError(false);
    } else {
      handleModelTypeChange(modelType || "");
    }
  }, [manufacturer]);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleEditMachine = () => {
    setOpenMachineDetails(true);
    setSerialNoError(false);
    setForbiddenCharError(false);
    handleCloseMenu();
  };
  const handleEditMachineStatus = () => {
    setOpenMachineDetailsStatus(true);

    handleCloseMenu();
  };
  async function updateMachineStatus(
    groupId: string,
    machineId: string,
    input: {
      machineCondition: string;
    },
  ) {
    try {
      if (input.machineCondition === machineStatus) {
        setOpenMachineDetailsStatus(false);
        store.dispatch(setShowAlert(t("machineupdatedstatus")));
        return;
      }

      await apiUpdateMachineInGroupStatus(groupId, machineId, input);

      store.dispatch(setShowAlert(t("machineupdatedstatus")));
      refreshMachineInfo();
      setOpenMachineDetailsStatus(false);

      setActiveStatus("");

      setSelectedImage(null);
      setSelectedImageSerial(null);
      setFileError(null);
      setFileErrorSerial(null);
      setSerialNoError(false);
      setForbiddenCharError(false);
      setmanufacturer(null);
      setmachinetypes(null);
      setmakerOther(null);
      setmachineTypeOther(null);
      setmodelType(null);
      setserialNo(null);
      setCustomerMachineNumber("");
      setMachineNumberError("");

      setMakerOtherError("");
      setMachineTypeOtherError("");
      setModelTypeError("");
      setOpenMachineDetails(false);
      setMediaFiles([]);
      setPictureFiles([]);

      setSerialNumberFiles([]);
      setIsImageRemoved(false);
      setIsImageRemovedSerial(false);
      clearImageState();
    } catch (error) {
      console.error("Error updating machine status:", error);
    }
  }
  const handleConvertMedia = async (files: File[]) => {
    const mediaArray = [];
    for await (const file of files) {
      if (file instanceof File) {
        const uploadedMedia = await handleUploadStore(
          UploadFileType.MACHINE,
          file,
        );
        if (uploadedMedia) {
          mediaArray.push({
            fileName: uploadedMedia.name || file.name,
            filePath: uploadedMedia.filePath,
            mediaUrl: uploadedMedia.filePath,
            mimeType: uploadedMedia.type || file.type,
          });
        }
      }
    }
    return mediaArray.filter((media) => media.fileName);
  };
  async function updateMachine(
    groupId: string,
    machineId: string,
    input: {
      machineName: string;
      machineManufacturerId: string;
      machineTypeId: string;
      modelAndType: string;
      serialNumber: string;
      customMachineManufacturerName?: string | null;
      customTypeName?: string | null;
    },
    pictureFiles: File[],
    pictureFilesSerial: File[],
  ) {
    const pictureMedia = await handleConvertMedia(pictureFiles);
    const serialNumberMedia = await handleConvertMedia(pictureFilesSerial);

    const detailResponse = await apiGetMachineDetailInfo(groupId, machineId);
    const existingDetail = detailResponse.data?.data ?? {};

    const dynamicInput = {
      ...buildMachineUpdatePayloadFromDetail(
        existingDetail,
        existingDetail.memo ?? null,
      ),
      machineName: input.machineName,
      machineManufacturerId: input.machineManufacturerId,
      machineTypeId: input.machineTypeId,
      modelAndType: input.modelAndType,
      serialNumber: input.serialNumber,
      ...(isImageRemoved
        ? { pictureUrl: null }
        : pictureMedia[0] && {
            pictureUrl:
              pictureMedia[0].filePath || pictureMedia[0].mediaUrl || null,
          }),
      ...(isImageRemovedSerial
        ? { serialNumberPlatePictureUrl: null }
        : serialNumberMedia[0] && {
            serialNumberPlatePictureUrl:
              serialNumberMedia[0].filePath ||
              serialNumberMedia[0].mediaUrl ||
              null,
          }),

      customMachineManufacturerName:
        input.machineManufacturerId !== OTHER_MANUFACTURER_ID
          ? null
          : input.customMachineManufacturerName,

      customTypeName:
        input.machineTypeId !== OTHER_MACHINE_TYPE_ID
          ? null
          : input.customTypeName,
    };

    try {
      await apiUpdateMachineInGroup(groupId, machineId, dynamicInput);

      store.dispatch(setShowAlert(t("machineupdated")));

      refreshMachineInfo();
      setActiveStatus("");

      setSelectedImage(null);
      setSelectedImageSerial(null);
      setFileError(null);
      setFileErrorSerial(null);

      setmanufacturer(null);
      setmachinetypes(null);
      setmakerOther(null);
      setmachineTypeOther(null);
      setmodelType(null);
      setserialNo(null);
      setCustomerMachineNumber("");

      setMachineNumberError("");
      setMakerOtherError("");
      setMachineTypeOtherError("");
      setModelTypeError("");
      setSerialNoError(false);
      setForbiddenCharError(false);
      setOpenMachineDetails(false);
      setMediaFiles([]);
      setPictureFiles([]);

      setSerialNumberFiles([]);
      setIsImageRemoved(false);
      setIsImageRemovedSerial(false);
      clearImageState();
    } catch (error) {
      console.error("Error updating machine:", error);
    }
  }

  const [isButtonVisiblePer, setIsButtonVisiblePer] = useState(false);
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await getUserPermissions();
        const userPermissions = response.data?.data;

        const targetGroupId = groupId;

        const matchingGroup = userPermissions.groups.find(
          (group: any) => group.groupId === targetGroupId,
        );

        if (matchingGroup && matchingGroup.permissions) {
          const permissions = matchingGroup.permissions;

          const hasPermission = Object.entries(permissions).some(
            ([key, value]) =>
              key === "MACHINES" && value === "READ_CREATE_UPDATE_DELETE",
          );

          setIsButtonVisiblePer(hasPermission);
        } else {
          setIsButtonVisiblePer(false);
        }
      } catch (error) {
        console.error("Failed to fetch permissions:", error);
        setIsButtonVisiblePer(false);
      }
    };

    fetchPermissions();
  }, [groupId]);

  const handleDownloadQR = async () => {
    if (
      !QRPictureUrl ||
      !machineInfo?.modelAndType ||
      !machineInfo?.serialNumber
    ) {
      console.warn("Missing data for PDF generation.");
      return;
    }

    try {
      const now = new Date();

      let datePart = "";
      if (userTimeFormat.startsWith("dd/MM")) {
        const d = String(now.getDate()).padStart(2, "0");
        const m = String(now.getMonth() + 1).padStart(2, "0");
        const y = now.getFullYear();
        datePart = `${d}/${m}/${y}`;
      } else if (userTimeFormat.startsWith("MM/dd")) {
        const d = String(now.getDate()).padStart(2, "0");
        const m = String(now.getMonth() + 1).padStart(2, "0");
        const y = now.getFullYear();
        datePart = `${m}/${d}/${y}`;
      } else if (userTimeFormat.startsWith("yyyy")) {
        const d = String(now.getDate()).padStart(2, "0");
        const m = String(now.getMonth() + 1).padStart(2, "0");
        const y = now.getFullYear();
        datePart = `${y}/${m}/${d}`;
      }

      const h = String(now.getHours()).padStart(2, "0");
      const min = String(now.getMinutes()).padStart(2, "0");
      const s = String(now.getSeconds()).padStart(2, "0");
      const timePart = `${h}:${min}:${s}`;

      const formattedDateTime = `${datePart}_${timePart}`
        .replace(/\//g, "-")
        .replace(/:/g, "-");

      const filename = `${t("qr")}_${machineInfo.modelAndType}_${
        machineInfo.serialNumber
      }_${formattedDateTime}.pdf`;

      const response = await apiGenerateQRPdf(
        machineInfo.modelAndType,
        machineInfo.serialNumber,
        QRPictureUrl,
        filename,
        customerMachineNumber,
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to generate and download PDF:", error);
    }
  };

  useEffect(() => {
    (async () => {
      if (
        machineInfo &&
        machineInfo?.modelAndType &&
        machineInfo?.serialNumber
      ) {
        setQRLoading(true);
        const result = await apiMachineQR(
          machineInfo?.modelAndType,
          machineInfo?.serialNumber,
        );
        setQRPictureUrl(result.data.data[0]?.qrImageUrl);
        setQRLoading(false);
      }
    })();
  }, [machineInfo]);

  const [cropOpen, setCropOpen] = useState(false);
  const [cropImage, setCropImage] = useState<string>("");
  const [cropFileName, setCropFileName] = useState<string>("");
  const [originalCropImage, setOriginalCropImage] = useState<string>("");
  const [originalCropFileName, setOriginalCropFileName] = useState<string>("");
  const getFileNameFromUrl = (url: string) => {
    const parsed = url.split("?")[0];
    const fileName = parsed.substring(parsed.lastIndexOf("/") + 1);
    return fileName || "image.jpeg";
  };

  const handleOpenEditCrop = async () => {
    try {
      if (originalCropImage) {
        setCropImage(originalCropImage);
        setCropFileName(originalCropFileName || "image.jpeg");
        setCropOpen(true);
        return;
      }

      if (!selectedImage) return;

      const response = await fetch(selectedImage);
      const blob = await response.blob();
      const fileName = getFileNameFromUrl(selectedImage);
      const blobFile = new File([blob], fileName, {
        type: blob.type || "image/jpeg",
      });
      const blobUrl = URL.createObjectURL(blobFile);

      setOriginalCropImage(blobUrl);
      setOriginalCropFileName(blobFile.name);
      setCropImage(blobUrl);
      setCropFileName(blobFile.name);
      setCropOpen(true);
    } catch (error) {
      console.error("Failed to prepare image for editing:", error);
    } finally {
      setMenuAnchor(null);
    }
  };

  const handleCropComplete = (croppedFile: File) => {
    const previewUrl = URL.createObjectURL(croppedFile);

    setPictureFiles([croppedFile]);
    setSelectedImage(previewUrl);
    setIsImageRemoved(false);
    setFileError(null);

    setCropOpen(false);
  };

  const showRequiredBadge =
    !manufacturer || !machinetypes || !modelType || !serialNo;
  return (
    <div className="machine-info sp-p24">
      <DataDialog
        open={openMachineDetailsStatus}
        setOpen={setOpenMachineDetailsStatus}
        title={t("machineInfo.status")}
        disableBackdropClick={true}
      >
        <div className="form-edit-name">
          <div className="icon-group justify-content-center">
            <div
              className={`icon success ${
                activeStatus === "NORMAL" ? "active" : ""
              }`}
              onClick={() => {
                setActiveStatus(MACHINE_CONDITION.NORMAL);
              }}
            >
              <IconCheck />
            </div>
            <div
              className={`icon warning ${
                activeStatus === "WARNING" ? "active" : ""
              }`}
              onClick={() => {
                setActiveStatus(MACHINE_CONDITION.WARNING);
              }}
            >
              <IconWarning />
            </div>
            <div
              className={`icon error ${
                activeStatus === "ERROR" ? "active" : ""
              }`}
              onClick={() => {
                setActiveStatus(MACHINE_CONDITION.ERROR);
              }}
            >
              <IconError />
            </div>
          </div>

          <div className="flex justify-content-end btn-group-footer mt-8">
            <Button
              onClick={() => {
                setOpenMachineDetailsStatus(false);
                setActiveStatus("");
              }}
              className="btn btn-no-border"
            >
              {t("dialogReport.cancel")}
            </Button>

            <Button
              size="small"
              className="btn btn-primary btn-save ml-10"
              style={{
                padding: "4px 10px",

                minWidth: "auto",
              }}
              onClick={() => {
                if (!groupId || !machineId) {
                  console.error("Group ID or Machine ID is undefined");
                  return;
                }

                updateMachineStatus(groupId, machineId, {
                  machineCondition: activeStatus,
                });
              }}
              disabled={!activeStatus}
            >
              {t("formAction.update")}
            </Button>
          </div>
        </div>

        <style>{`
    .icon-group {
    margin-top: -20px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px; 
      margin-bottom: 20px;
    }
    .icon-group .icon {
      font-size: 50px; 
      cursor: pointer;
      opacity: 0.5; 
      transition: transform 0.2s, opacity 0.2s; 
      transform: scale(2.0);
    }
    .icon-group .icon.active {
      opacity: 1; 
      transform: scale(2.2); 
    }
    .icon-group .icon.success.active {
      color: green;
    }
    .icon-group .icon.warning.active {
      color: orange;
    }
    .icon-group .icon.error.active {
      color: red;
    }
    .icon-group .icon.warning {
  background: none; 
  border: none; 
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0; 
}
  `}</style>
      </DataDialog>

      <DataDialog
        open={openMachineDetails}
        setOpen={setOpenMachineDetails}
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span>{t("machineInfo.title")}</span>
            {showRequiredBadge && (
              <span style={{ color: "red", fontSize: "12px", fontWeight: 500 }}>
                {t("required")}*
              </span>
            )}
          </div>
        }
        className="dialog-inspection-form"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
        disableBackdropClick={true}
      >
        <div
          className="flex p-4 gap-6"
          style={{
            backgroundColor: "#f5f6f9",
            padding: "16px",
            gap: "20px",
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            alignItems: isSmallScreen ? "center" : "flex-start",
            flexWrap: isSmallScreen ? "nowrap" : "wrap",
          }}
        >
          <div style={{ flex: isSmallScreen ? "1" : "0 0 160px" }}>
            <FormControl fullWidth>
              <div
                className="image-box-container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "0px",
                }}
              >
                <div
                  className="image-box"
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    height: "150px",
                    border: "1px dashed #ccc",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "4px",
                    backgroundColor: "transparent",
                    position: "relative",
                    marginTop: isSmallScreen ? "0px" : "60px",
                  }}
                >
                  {selectedImage ? (
                    <>
                      <img
                        src={selectedImage}
                        alt="Preview"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                        onClick={(event) => setMenuAnchor(event.currentTarget)}
                      />
                      <Menu
                        anchorEl={menuAnchor}
                        open={Boolean(menuAnchor)}
                        onClose={() => setMenuAnchor(null)}
                      >
                        <MenuItem
                          onClick={() => {
                            setPreviewOpen(true);
                            setMenuAnchor(null);
                          }}
                        >
                          <Visibility
                            style={{ marginRight: "7px", color: "#4a4a4a" }}
                          />
                          {t("preview")}
                        </MenuItem>
                        <Divider style={{ margin: "4px 0" }} />
                        <MenuItem onClick={handleOpenEditCrop}>
                          <Edit
                            style={{ marginRight: "7px", color: "#4a4a4a" }}
                          />
                          {t("formAction.edit")}
                        </MenuItem>
                        <Divider style={{ margin: "4px 0" }} />
                        <MenuItem
                          onClick={() => {
                            setPictureFiles([]);
                            setSelectedImage(null);
                            setIsImageRemoved(true);
                            setOriginalCropImage("");
                            setOriginalCropFileName("");
                            setCropImage("");
                            setCropFileName("");
                            setMenuAnchor(null);
                          }}
                        >
                          <IconDeleteRow />

                          <span style={{ marginLeft: "7px" }}>
                            {t("machineInfo.removeimage")}
                          </span>
                        </MenuItem>
                      </Menu>
                    </>
                  ) : fileError ? (
                    <span
                      style={{
                        color: "red",
                        fontSize: "12px",
                        textAlign: "center",
                        position: "absolute",
                      }}
                    >
                      {fileError}
                    </span>
                  ) : (
                    <span style={{ color: "#ccc" }}>
                      {t("machineInfo.noimage")}
                    </span>
                  )}
                </div>
              </div>

              <input
                id="image-upload"
                type="file"
                accept=".png, .jpg, .jpeg, .gif, .heic"
                onChange={async (event) => {
                  const file = event.target.files?.[0];
                  if (!file) return;

                  const validImageTypes = [
                    "image/png",
                    "image/jpeg",
                    "image/jpg",
                    "image/gif",
                    "image/heic",
                  ];

                  const fileType = file.type;
                  const fileExtension = file.name
                    .split(".")
                    .pop()
                    ?.toLowerCase();

                  const isValidFile = await isValidMediaFile(file);
                  if (!isValidFile) {
                    setPictureFiles([]);
                    setSelectedImage(null);
                    setFileError(t("messages.corruptFileType"));
                    event.target.value = "";
                    return;
                  }

                  const isHeic =
                    fileType === "image/heic" ||
                    (!fileType && fileExtension === "heic");

                  let finalFile = file;

                  if (
                    validImageTypes.includes(fileType) ||
                    (!fileType && fileExtension === "heic")
                  ) {
                    try {
                      if (isHeic) {
                        const convertedBlob = await heic2any({
                          blob: file,
                          toType: "image/jpeg",
                        });

                        finalFile = new File(
                          [convertedBlob as Blob],
                          file.name.replace(/\.heic$/i, ".jpeg"),
                          { type: "image/jpeg" },
                        );
                      }

                      const previewUrl = URL.createObjectURL(finalFile);

                      setCropImage(previewUrl);
                      setCropFileName(finalFile.name);
                      setOriginalCropImage(previewUrl);
                      setOriginalCropFileName(finalFile.name);
                      setCropOpen(true);

                      setFileError(null);
                    } catch (error) {
                      setPictureFiles([]);
                      setSelectedImage(null);
                      setFileError(t("machineInfo.errormessage"));
                    }
                  } else {
                    setPictureFiles([]);
                    setSelectedImage(null);
                    setFileError(t("machineInfo.errormessage"));
                  }

                  event.target.value = "";
                }}
                style={{ display: "none" }}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  component="label"
                  className="btn btn-primary"
                  htmlFor="image-upload"
                  style={{
                    width: "160px",
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    backgroundColor: "#e2f2ff",
                    color: "#1e2c39",
                    marginBottom: "16px",
                    marginTop: "10px",
                  }}
                >
                  <UploadOutlined className="mr-5" />
                  {t("machineInfo.uploadimage")}
                </Button>
              </div>
              <Dialog
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogContent
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "20px",
                    backgroundColor: "transparent",
                  }}
                >
                  <IconButton
                    aria-label="close preview"
                    onClick={() => setPreviewOpen(false)}
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                    }}
                  >
                    <Close />
                  </IconButton>
                  <img
                    src={selectedImage || undefined}
                    alt="Full Preview"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "80vh",
                      objectFit: "contain",
                    }}
                  />
                </DialogContent>
              </Dialog>
            </FormControl>
          </div>

          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                  }}
                >
                  <TextField
                    label={`${t("machineInfo.customerMachineNumber")}`}
                    error={!!machineNumberError}
                    className="input-field"
                    value={customerMachineNumber}
                    onChange={(e) => {
                      if (e.target.value.length <= 40) {
                        handleMachineNumberChange(e.target.value);
                      }
                    }}
                    inputProps={{ maxLength: 40 }}
                    InputProps={{
                      endAdornment: machineNumberError && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <IconInputError />
                        </div>
                      ),
                    }}
                  />

                  {machineNumberError ? (
                    <span className="error-text fs-12 ml-15 txt-red">
                      {machineNumberError}
                    </span>
                  ) : (
                    <span className="fs-12 ml-15 txt-gray-1"></span>
                  )}
                </FormControl>

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                    marginTop: "8px",
                  }}
                >
                  <TextField
                    select
                    label={`${t("machineInfo.maker")}*`}
                    value={manufacturer || ""}
                    onChange={(event) => {
                      const selectedId = event.target.value;
                      setmanufacturer(selectedId);
                    }}
                    error={!manufacturer}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            width: 250,
                          },
                        },
                      },
                    }}
                  >
                    {manufacturers.map((manufacturer) => (
                      <MenuItem
                        key={manufacturer.machine_manufacturer_id}
                        value={manufacturer.machine_manufacturer_id}
                      >
                        {manufacturer.machine_manufacturer_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                {manufacturer === OTHER_MANUFACTURER_ID && (
                  <FormControl
                    style={{
                      flex: isSmallScreen
                        ? "1 1 100%"
                        : "1 1 calc(50% - 7.5px)",
                    }}
                  >
                    <TextField
                      label={`${t("machineInfo.makerOther")}`}
                      value={makerOther}
                      error={!!makerOtherError}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          handleMakerOtherChange(e.target.value);
                        }
                      }}
                      inputProps={{ maxLength: 20 }}
                      InputProps={{
                        endAdornment: makerOtherError && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <IconInputError />
                          </div>
                        ),
                      }}
                      className="input-field"
                    />

                    {makerOtherError ? (
                      <span className="error-text fs-12 ml-15 txt-red">
                        {makerOtherError}
                      </span>
                    ) : (
                      <span className="fs-12 ml-15 txt-gray-1"></span>
                    )}
                  </FormControl>
                )}

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                    marginTop: "8px",
                  }}
                >
                  <TextField
                    select
                    label={`${t("machineInfo.machineType")}*`}
                    value={machinetypes || ""}
                    onChange={(event) => {
                      const selectedId = event.target.value;
                      setmachinetypes(selectedId);
                    }}
                    error={!machinetypes}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          style: {
                            maxHeight: 200,
                            width: 250,
                          },
                        },
                      },
                    }}
                  >
                    {machinetype.map((type) => (
                      <MenuItem
                        key={type.machine_type_id}
                        value={type.machine_type_id}
                      >
                        {type.type_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
                {machinetypes === OTHER_MACHINE_TYPE_ID && (
                  <FormControl
                    style={{
                      flex: isSmallScreen
                        ? "1 1 100%"
                        : "1 1 calc(50% - 7.5px)",
                    }}
                  >
                    <TextField
                      label={`${t("machineInfo.machineTypeOther")}`}
                      value={machineTypeOther}
                      onChange={(e) => {
                        if (e.target.value.length <= 40) {
                          handleMachineTypeOtherChange(e.target.value);
                        }
                      }}
                      inputProps={{ maxLength: 40 }}
                      fullWidth
                      error={!!machineTypeOtherError}
                      InputProps={{
                        endAdornment: machineTypeOtherError && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            <IconInputError />
                          </div>
                        ),
                      }}
                      className="input-field"
                    />

                    {machineTypeOtherError ? (
                      <span className="error-text fs-12 ml-15 txt-red">
                        {machineTypeOtherError}
                      </span>
                    ) : (
                      <span className="fs-12 ml-15 txt-gray-1"></span>
                    )}
                  </FormControl>
                )}

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                  }}
                >
                  <TextField
                    label={`${t("machineInfo.modelType")}*`}
                    error={!modelType || !!modelTypeError}
                    value={modelType ?? ""}
                    onChange={(e) => {
                      if (e.target.value.length <= 40) {
                        handleModelTypeChange(e.target.value);
                      }
                    }}
                    onPaste={(event) => {
                      event.preventDefault();
                      let pastedText = event.clipboardData.getData("text");
                      handleModelTypeChange(pastedText);
                    }}
                    inputProps={{ maxLength: 40 }}
                    InputProps={{
                      endAdornment: (!modelType || modelTypeError) && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                          }}
                        >
                          <IconInputError />
                        </div>
                      ),
                    }}
                    className="input-field"
                  />
                </FormControl>

                <FormControl
                  style={{
                    flex: isSmallScreen ? "1 1 100%" : "1 1 calc(50% - 7.5px)",
                  }}
                >
                  <TextField
                    label={`${t("machineInfo.serialNo")}*`}
                    error={
                      !serialNo ||
                      serialNoError ||
                      forbiddenCharError ||
                      (manufacturer === KOMATSU_MANUFACTURER_ID &&
                        (machinetypes === OTHER_MACHINE_TYPE_ID
                          ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                              serialNo,
                            )
                          : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                              serialNo,
                            )))
                    }
                    value={serialNo ?? ""}
                    onChange={(event) => {
                      handleSerialNumberChange(event.target.value);
                    }}
                    onKeyDown={(event) => {
                      const allowedKeys = /^[A-Za-z0-9- ０-９Ａ-Ｚａ-ｚ]$/; // Added hyphen/space for non-Komatsu
                      const navigationKeys = [
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                        "Enter",
                      ];

                      if (
                        !allowedKeys.test(event.key.toUpperCase()) &&
                        event.key !== "Backspace" &&
                        event.key !== "Delete" &&
                        !navigationKeys.includes(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(event) => {
                      event.preventDefault();
                      let pastedText = event.clipboardData.getData("text");
                      pastedText =
                        manufacturer === KOMATSU_MANUFACTURER_ID
                          ? pastedText.toUpperCase()
                          : pastedText;
                      // Non-Komatsu: keep hyphens/spaces; Komatsu: strip non-alphanum
                      const allowedChars =
                        manufacturer === KOMATSU_MANUFACTURER_ID
                          ? /^[A-Z0-9０-９Ａ-Ｚａ-ｚ]$/
                          : /^[A-Za-z0-9- ０-９Ａ-Ｚａ-ｚ]$/;
                      const sanitizedText = pastedText
                        .split("")
                        .filter((c) => allowedChars.test(c))
                        .join("");
                      handleSerialNumberChange(sanitizedText);
                    }}
                    helperText={
                      forbiddenCharError ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("machineInfo.serialNoTooLong")}
                        </span>
                      ) : manufacturer === KOMATSU_MANUFACTURER_ID &&
                        serialNo &&
                        (machinetypes === OTHER_MACHINE_TYPE_ID
                          ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                              serialNo,
                            )
                          : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                              serialNo,
                            )) ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("machineInfo.serialNoTooLong")}
                        </span>
                      ) : serialNo && serialNo.length > 20 ? (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          {t("machineInfo.serialNoTooLong")}
                        </span>
                      ) : null
                    }
                    InputProps={{
                      endAdornment: (!serialNo ||
                        serialNoError ||
                        forbiddenCharError ||
                        (manufacturer === KOMATSU_MANUFACTURER_ID &&
                          (machinetypes === OTHER_MACHINE_TYPE_ID
                            ? !/^(NL\d{1,8}|(DB|DZ)[A-Z0-9]{1,8}|[ABCFHJKNY][0-9]{1,9}|[0-9]{1,10})$/.test(
                                serialNo,
                              )
                            : !/^(NL\d{1,6}|(DB|DZ)[A-Z0-9]{1,6}|[ABCFHJKNY][0-9]{1,7}|[0-9]{1,8})$/.test(
                                serialNo,
                              )))) && <IconInputError />,
                    }}
                    className="input-field"
                  />
                </FormControl>
              </div>
            </div>

            <div
              className="wrapper-text-field mt-8"
              style={{ marginBottom: "0px" }}
            >
              <MediaUploadMachine
                key={refreshKey}
                setFileCount={setFileCount}
                medias={mediaFiles}
                setMedias={(files: File[]) => {
                  const existingFiles = mediaFiles.map(
                    (file: any) =>
                      file.filePath || file.mediaUrl || file.thumbnailUrl,
                  );
                  const newFiles = files.map(
                    (file: any) => file.filePath || file.mediaUrl,
                  );
                  const removedFiles = existingFiles.filter(
                    (mediaUrl: string) => !newFiles.includes(mediaUrl),
                  );
                  if (removedFiles.length > 0) {
                    setRemovedMediaUrls((prev: any) => [
                      ...prev,
                      ...removedFiles,
                    ]);
                  }
                  setMediaFiles(files);
                  setFileCount(files.length);
                }}
                typeFile={TYPE_FILE_UPLOAD.image}
                uploadDescription={uploadDescription}
              />
            </div>
          </div>
        </div>

        <div
          className="flex justify-content-end btn-group-footer mt-8"
          style={{
            backgroundColor: "#fff",
            paddingTop: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          <Button
            onClick={() => {
              setSelectedImage(null);
              setSelectedImageSerial(null);
              setFileError(null);
              setFileErrorSerial(null);

              setmanufacturer(null);
              setmachinetypes(null);
              setmakerOther(null);
              setmachineTypeOther(null);
              setmodelType(null);
              setserialNo(null);
              setCustomerMachineNumber("");

              setMachineNumberError("");
              setMakerOtherError("");
              setMachineTypeOtherError("");
              setModelTypeError("");
              setSerialNoError(false);
              setForbiddenCharError(false);
              setOpenMachineDetails(false);
              setMediaFiles([]);
              setPictureFiles([]);

              setSerialNumberFiles([]);
              setIsImageRemoved(false);
              setIsImageRemovedSerial(false);
            }}
            className="btn btn-no-border"
          >
            {t("dialogReport.cancel")}
          </Button>

          <Button
            className="btn btn-primary btn-save ml-10"
            onClick={() => {
              if (groupId && machineId) {
                updateMachine(
                  groupId,
                  machineId,
                  {
                    machineName:
                      customerMachineNumber?.trim() ||
                      `${modelType}-${serialNo}`,
                    machineManufacturerId: manufacturer || "",
                    machineTypeId: machinetypes || "",
                    modelAndType: modelType || "",
                    serialNumber: serialNo || "",
                    customMachineManufacturerName: makerOther || null,
                    customTypeName: machineTypeOther || null,
                  },
                  pictureFiles,

                  mediaFiles,
                );
              } else {
                console.error("Group ID or Machine Id is undefined");
              }
            }}
            disabled={
              serialNoError ||
              !!machineTypeOtherError ||
              !!modelTypeError ||
              !!makerOtherError ||
              !!machineNumberError ||
              !manufacturer ||
              !machinetype ||
              !modelType ||
              !serialNo ||
              (manufacturer === KOMATSU_MANUFACTURER_ID &&
                (machinetypes === OTHER_MACHINE_TYPE_ID
                  ? serialNo.length > 10
                  : serialNo.length > 8))
            }
          >
            {t("formAction.update")}
          </Button>
        </div>
      </DataDialog>

      <div
        ref={pdfRef}
        style={{
          visibility: "hidden",
          position: "absolute",
          left: "-9999px",
          top: "0",
          padding: "40px",
          width: "595px",
          height: "842px",
          backgroundColor: "#f5f5f5",
          zIndex: -1,
        }}
      >
        <div
          style={{
            border: "1px solid #ccc",
            padding: "40px",
            backgroundColor: "#fff",
            width: "100%",
            height: "100%",
          }}
        >
          {QRPictureUrl && (
            <img
              src={QRPictureUrl}
              alt="QR"
              style={{ width: "150px", height: "150px", marginBottom: "20px" }}
            />
          )}
          <h2 style={{ margin: "8px 0" }}>
            Model-Type: {machineInfo?.modelAndType}
          </h2>
          <h3 style={{ margin: "8px 0" }}>
            Serial Number: {machineInfo?.serialNumber}
          </h3>
        </div>
      </div>

      <div className="wrapper-dropdown-info">
        <div className="wrapper-image">
          {!machineInfo?.pictureUrl ? (
            <Skeleton
              variant="rectangular"
              className="info-image"
              width="100%"
              height={200}
            />
          ) : machineInfoPictureUrl ? (
            <Box
              className="info-image"
              component="img"
              alt="info-image"
              src={machineInfoPictureUrl}
              onError={() => setMachineInfoPictureUrl(undefined)}
            />
          ) : (
            <Box className="info-image">
              <IconInvalidUrl />
            </Box>
          )}

          <div
            className="info-status flex align-items-center justify-content-between mt-10"
            style={{ width: "100%" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="flex align-items-center"
              style={{ flex: 1, minWidth: 0 }}
            >
              <span
                className="text mr-10 font-bold"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {!machineInfo?.machineName ? (
                  <Skeleton width={120} height={20} />
                ) : (
                  <DataTooltip isTextPre width="100%">
                    {machineInfo?.machineName ?? ""}
                  </DataTooltip>
                )}
              </span>

              {machineInfo?.machineCondition === "NORMAL" && <IconCheckDone />}
              {machineInfo?.machineCondition === "WARNING" && <IconWarning />}
              {machineInfo?.machineCondition === "ERROR" && <IconError />}
            </div>

            {machineInfo?.machineName && isButtonVisiblePer && (
              <div onClick={(e) => e.stopPropagation()}>
                <IconButton
                  aria-label="more"
                  aria-controls={openMenu ? "machine-menu" : undefined}
                  aria-haspopup="true"
                  size="small"
                  onClick={handleMenuClick}
                >
                  <MoreVertIcon
                    fontSize="small"
                    style={{ transform: "rotate(90deg)" }}
                  />
                </IconButton>
              </div>
            )}

            {machineInfo?.machineName && (
              <Menu
                id="machine-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <MenuItem onClick={handleEditMachine}>
                  <ListItemIcon>
                    <IconEdit />
                  </ListItemIcon>
                  <ListItemText primary={t("machineTable.editMachine")} />
                </MenuItem>
                <MenuItem onClick={handleEditMachineStatus}>
                  <ListItemIcon>
                    {machineStatus in STATUS_ICONS ? (
                      STATUS_ICONS[machineStatus as MACHINE_CONDITION]
                    ) : (
                      <IconError />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={t("machineTable.editMachineStatus")} />
                </MenuItem>
              </Menu>
            )}
          </div>
        </div>

        <KeyboardArrowDown
          className={`icon-arrow-down ${showContentDrop ? "rotate-180" : ""}`}
          onClick={() => setShowContentDrop(!showContentDrop)}
          style={{ cursor: "pointer" }}
        />
      </div>

      {showContentDrop && (
        <div className="info-list mt-20">
          {!machineInfo?.machineManufacturerName ? (
            <div className="info-item">
              <span className="info-item-label">
                <Skeleton width="80px" height="20px" />
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                <Skeleton width="100%" height="24px" />
              </div>
            </div>
          ) : (
            <div className="info-item">
              <span className="info-item-label">{t("machineInfo.maker")}</span>
              <div className="info-item-content word-break txt-pre-wrap">
                {machineInfo?.machineManufacturerName}
              </div>
            </div>
          )}
          {!machineInfo?.machineTypeName && !machineInfo?.customTypeName ? (
            <div className="info-item">
              <span className="info-item-label">
                <Skeleton width="100px" height="20px" />
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                <Skeleton width="100%" height="24px" />
              </div>
            </div>
          ) : (
            <div className="info-item">
              <span className="info-item-label">
                {t("machineInfo.machineType")}
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                {machineInfo?.isOtherMachineType && machineInfo?.customTypeName
                  ? machineInfo?.customTypeName
                  : machineInfo?.machineTypeName}
              </div>
            </div>
          )}
          {!machineInfo?.modelAndType ? (
            <div className="info-item">
              <span className="info-item-label">
                <Skeleton width="90px" height="20px" />
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                <Skeleton width="100%" height="24px" />
              </div>
            </div>
          ) : (
            <div className="info-item">
              <span className="info-item-label">
                {t("machineInfo.modelType")}
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                {machineInfo?.modelAndType}
              </div>
            </div>
          )}
          {!machineInfo?.serialNumber ? (
            <div className="info-item">
              <span className="info-item-label">
                <Skeleton width="85px" height="20px" />
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                <Skeleton width="100%" height="24px" />
                <Skeleton
                  variant="rectangular"
                  className="info-image"
                  width="100%"
                  height={200}
                />
              </div>
            </div>
          ) : (
            <div className="info-item">
              <span className="info-item-label">
                {t("machineInfo.serialNo")}
              </span>
              <div className="info-item-content word-break txt-pre-wrap">
                {machineInfo?.serialNumberPlatePictureUrl ? (
                  <span
                    className={
                      machineInfo?.serialNumberPlatePictureUrl &&
                      "has-text-link pointer"
                    }
                    onClick={() => handleOnClick(machineInfo)}
                  >
                    {machineInfo?.serialNumber}
                  </span>
                ) : (
                  machineInfo?.serialNumber
                )}
              </div>

              <MachineMemoSection
                memo={machineInfo.memo}
                groupId={groupId}
                machineId={machineId}
                onMemoUpdated={refreshMachineInfo}
              />

              {!QRLoading && QRPictureUrl ? (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <img
                    src={QRPictureUrl}
                    alt={t("MachineQR")}
                    style={{
                      maxWidth: "200px",
                      backgroundColor: "transparent",
                    }}
                  />
                  <br />
                  <span
                    onClick={handleDownloadQR}
                    style={{
                      display: "inline-block",
                      marginTop: "8px",
                      cursor: "pointer",
                    }}
                    title={t("MachineQR")}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="black"
                      stroke="black"
                      strokeWidth="1.5"
                    >
                      <path d="M5 20h14v-2H5v2zM11 4v8H8l4 4 4-4h-3V4z" />
                    </svg>
                  </span>
                </div>
              ) : (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Skeleton
                    variant="rectangular"
                    className="info-image"
                    width="100%"
                    height={200}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {serialNumberPlatePictureUrl && (
        <DataDialog
          title={t("serialNumberPlate")}
          disableBackdropClick={true}
          open={open}
          dialogActions={
            <Button
              onClick={() => setOpen(false)}
              className="btn btn-no-border"
            >
              {t("dialogRefuel.close")}
            </Button>
          }
        >
          {serialNumberPlatePictureUrl === INVALID_URL ? (
            <Box
              sx={{
                width: 512,
                height: 512,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IconInvalidUrl />
            </Box>
          ) : (
            <img
              className="img-dialog"
              src={`${machineInfo.serialNumberPlatePictureUrl}`}
              alt={machineInfo?.machineManufacturerName}
              loading="lazy"
              onError={() => {
                setSerialNumberPlatePictureUrl(INVALID_URL);
              }}
            />
          )}
        </DataDialog>
      )}

      <ImageCropDialog
        open={cropOpen}
        image={cropImage}
        fileName={cropFileName}
        onClose={() => setCropOpen(false)}
        onComplete={handleCropComplete}
      />
    </div>
  );
}
